var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/core-js/object/values", "core-js/modules/es6.string.big", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "classnames", "debounce", "prop-types", "react", "../../../../breakpoints", "../../../../sliderHelpers", "../../Teasers/TeaserSeeAll/TeaserSeeAll", "../../Teasers/TeaserShow/TeaserShow", "../../UI/Icon/ArrowLeft", "../../UI/Icon/ArrowRight", "../../UI/TitlesElement/TitlesElement", "./MultiLineSlideBig", "./MultiLineSlideDual", "./MultiLineSlider.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/core-js/object/values"), require("core-js/modules/es6.string.big"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("classnames"), require("debounce"), require("prop-types"), require("react"), require("../../../../breakpoints"), require("../../../../sliderHelpers"), require("../../Teasers/TeaserSeeAll/TeaserSeeAll"), require("../../Teasers/TeaserShow/TeaserShow"), require("../../UI/Icon/ArrowLeft"), require("../../UI/Icon/ArrowRight"), require("../../UI/TitlesElement/TitlesElement"), require("./MultiLineSlideBig"), require("./MultiLineSlideDual"), require("./MultiLineSlider.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.values, global.es6String, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.classnames, global.debounce, global.propTypes, global.react, global.breakpoints, global.sliderHelpers, global.TeaserSeeAll, global.TeaserShow, global.ArrowLeft, global.ArrowRight, global.TitlesElement, global.MultiLineSlideBig, global.MultiLineSlideDual, global.MultiLineSlider);
    global.BaseMultiLineSlider = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _values, _es6String, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _classnames, _debounce, _propTypes, _react, _breakpoints, _sliderHelpers, _TeaserSeeAll, _TeaserShow, _ArrowLeft, _ArrowRight, _TitlesElement, _MultiLineSlideBig, _MultiLineSlideDual, _MultiLineSlider) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.getTeaserFromKind = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _values = _interopRequireDefault(_values);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _classnames = _interopRequireDefault(_classnames);
  _debounce = _interopRequireDefault(_debounce);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _TeaserSeeAll = _interopRequireDefault(_TeaserSeeAll);
  _TeaserShow = _interopRequireDefault(_TeaserShow);
  _ArrowLeft = _interopRequireDefault(_ArrowLeft);
  _ArrowRight = _interopRequireDefault(_ArrowRight);
  _TitlesElement = _interopRequireDefault(_TitlesElement);
  _MultiLineSlideBig = _interopRequireDefault(_MultiLineSlideBig);
  _MultiLineSlideDual = _interopRequireDefault(_MultiLineSlideDual);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var NextArrow = function NextArrow(_ref) {
    var onClick = _ref.onClick,
        stateClass = _ref.stateClass,
        touchDevice = _ref.touchDevice;
    return /*#__PURE__*/_react.default.createElement(_MultiLineSlider.StyledArrowNext, {
      "aria-hidden": true,
      className: (0, _classnames.default)('next-slider__next', stateClass),
      onClick: onClick,
      tabIndex: "-1",
      touchDevice: touchDevice
    }, /*#__PURE__*/_react.default.createElement(_ArrowRight.default, {
      size: {
        default: 'xsmall',
        medium: 'medium'
      }
    }));
  };

  NextArrow.propTypes = {
    onClick: _propTypes.default.func,
    stateClass: _propTypes.default.string,
    touchDevice: _propTypes.default.bool
  };

  var PrevArrow = function PrevArrow(_ref2) {
    var onClick = _ref2.onClick,
        stateClass = _ref2.stateClass,
        touchDevice = _ref2.touchDevice;
    return /*#__PURE__*/_react.default.createElement(_MultiLineSlider.StyledArrowPrev, {
      "aria-hidden": true,
      className: (0, _classnames.default)('next-slider__prev', stateClass),
      onClick: onClick,
      tabIndex: "-1",
      touchDevice: touchDevice
    }, /*#__PURE__*/_react.default.createElement(_ArrowLeft.default, {
      size: {
        default: 'xsmall',
        medium: 'medium'
      }
    }));
  };

  PrevArrow.propTypes = {
    onClick: _propTypes.default.func,
    stateClass: _propTypes.default.string,
    touchDevice: _propTypes.default.bool
  };
  var components = {
    TeaserShow: _TeaserShow.default,
    TeaserSeeAll: _TeaserSeeAll.default
  };

  var getTeaserFromKind = function getTeaserFromKind(kind) {
    return components[kind !== 'SEEALL' ? 'TeaserShow' : 'TeaserSeeAll'];
  };

  _exports.getTeaserFromKind = getTeaserFromKind;

  var haveLessThan = function haveLessThan(teasers, props, n) {
    return props.placeholders > 0 ? props.placeholders < n : teasers.filter(function (teaser) {
      return teaser.kind !== 'SEEALL';
    }).length < n;
  };

  var haveMoreThan = function haveMoreThan(teasers, props, n) {
    return props.placeholders > 0 ? props.placeholders > n : teasers.filter(function (teaser) {
      return teaser.kind !== 'SEEALL';
    }).length > n;
  };

  var BaseMultiLineSlider = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(BaseMultiLineSlider, _Component);

    var _super = _createSuper(BaseMultiLineSlider);

    function BaseMultiLineSlider(_props) {
      var _this;

      (0, _classCallCheck2.default)(this, BaseMultiLineSlider);
      _this = _super.call(this, _props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQueryS", function (media) {
        if (media.matches) {
          _this.onChangedMediaQuery('S');
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQueryM", function (media) {
        if (media.matches) {
          _this.onChangedMediaQuery('M');
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQueryXL", function (media) {
        if (media.matches) {
          _this.onChangedMediaQuery('XL');
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQuery", function (size) {
        // we have to re-render with the new viewport
        _this.setState({
          hideNext: _this.slides.scrollWidth === _this.slides.offsetWidth,
          isSmallDevice: size === 'S',
          showPrev: false,
          showNext: _this.slides.offsetWidth < _this.slides.scrollWidth,
          translateIndex: 0,
          translateWidths: [],
          translateX: 0
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onWindowScroll", function () {
        (0, _sliderHelpers.checkSliderVisibility)(function (_ref3) {
          var visible = _ref3.visible;
          global.removeEventListener('scroll', _this.onWindowScrollDebounce);

          _this.setState({
            hideNext: _this.slides.scrollWidth === _this.slides.offsetWidth,
            visible: visible
          });
        }, _this.slides);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPrevArrowClick", function () {
        return _this.onArrowClick(-1);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNextArrowClick", function () {
        return _this.onArrowClick(1);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initSlider", function (el) {
        _this.slider = el;
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initSlides", function (el) {
        _this.slides = el;
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sortTeasers", function (accumulator, teaser) {
        if (!teaser) {
          return accumulator;
        }

        var _this$state = _this.state,
            isSmallDevice = _this$state.isSmallDevice,
            lessThan4Items = _this$state.lessThan4Items,
            moreThan5Items = _this$state.moreThan5Items;

        if (!isSmallDevice && _this.props.reverse && teaser.big && !lessThan4Items) {
          var pushIndex = 2;

          if (!lessThan4Items && !moreThan5Items) {
            pushIndex = 1;
          }

          accumulator.splice(pushIndex, 0, (0, _values.default)(teaser)[0]);
        } else {
          accumulator.unshift((0, _values.default)(teaser)[0]);
        }

        return accumulator;
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderBig", function (teaser, props) {
        var breakpointFormat = {
          xsmall: 'square',
          small: 'square',
          medium: 'landscape',
          large: 'landscape',
          xlarge: 'square',
          xxlarge: 'square'
        };
        var id = teaser.id || teaser.title;

        var slide = /*#__PURE__*/_react.default.createElement(_MultiLineSlideBig.default, (0, _extends2.default)({
          key: "".concat(id, "-").concat(props.index),
          teaser: teaser,
          breakpointFormat: breakpointFormat
        }, props));

        return {
          big: slide
        };
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderDual", function (teasers, props) {
        if (!teasers.length) {
          return null;
        }

        if (teasers[0].kind === 'SEEALL') {
          return _this.renderBig(teasers[0], props);
        }

        var breakpointFormat = {
          xsmall: 'square',
          small: 'square',
          medium: 'square',
          large: 'square',
          xlarge: 'landscape',
          xxlarge: 'landscape'
        };
        var teasersIds = teasers.map(function (t) {
          return t.id || t.title;
        }).concat(props.index).join('-');

        var slide = /*#__PURE__*/_react.default.createElement(_MultiLineSlideDual.default, (0, _extends2.default)({
          key: teasersIds,
          teasers: teasers,
          breakpointFormat: breakpointFormat
        }, props));

        return {
          dual: slide
        };
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderChilds", function () {
        var _this$props = _this.props,
            teasers = _this$props.teasers,
            placeholders = _this$props.placeholders;
        var _this$state2 = _this.state,
            isSmallDevice = _this$state2.isSmallDevice,
            lessThan4Items = _this$state2.lessThan4Items,
            moreThan5Items = _this$state2.moreThan5Items,
            visible = _this$state2.visible;
        return teasers.map(function (teaser, index) {
          var bigSlideCount = isSmallDevice ? 0 : 4;

          if (!lessThan4Items) {
            bigSlideCount = moreThan5Items ? 1 : 2;
          }

          var bigSlideIndex = bigSlideCount - 1;
          var teaserProps = {
            index: index,
            placeholders: placeholders,
            visible: visible
          };

          if (index <= bigSlideIndex) {
            if (index === 0 && isSmallDevice) {
              return null;
            }

            return _this.renderBig(teaser, teaserProps);
          } else if ((index - bigSlideIndex) % 2 === 1) {
            return _this.renderDual([teaser].concat(_this.props.teasers[index + 1] || []), teaserProps);
          }

          return null;
        }).reduceRight(_this.sortTeasers, []);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSlider", function () {
        var _this$state3 = _this.state,
            hideNext = _this$state3.hideNext,
            showNext = _this$state3.showNext,
            showPrev = _this$state3.showPrev,
            touchDevice = _this$state3.touchDevice,
            translateX = _this$state3.translateX,
            visible = _this$state3.visible; // manage slider arrows

        var nextArrowClass = hideNext || !showNext || !visible ? 'invisible' : '';
        var prevArrowClass = !showPrev || !visible ? 'invisible' : '';

        var slides = _this.renderChilds();

        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('next-multilines-slider', {
            'touch-device': touchDevice
          })
        }, /*#__PURE__*/_react.default.createElement(PrevArrow, {
          stateClass: prevArrowClass,
          onClick: _this.onPrevArrowClick,
          touchDevice: touchDevice
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "next-multilines-slider__wrapper",
          ref: _this.initSlider
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "next-multilines-slider__slides",
          style: {
            transform: "translate3d(".concat(translateX, "px, 0, 0)")
          },
          ref: _this.initSlides
        }, slides)), /*#__PURE__*/_react.default.createElement(NextArrow, {
          stateClass: nextArrowClass,
          onClick: _this.onNextArrowClick,
          touchDevice: touchDevice
        }));
      });
      _this.state = {
        hideNext: false,
        isSmallDevice: false,
        lessThan4Items: haveLessThan(_props.teasers, _props, 4),
        moreThan5Items: haveMoreThan(_props.teasers, _props, 5),
        showPrev: false,
        showNext: true,
        touchDevice: false,
        translateIndex: 0,
        translateWidths: [],
        translateX: 0,
        visible: false
      };
      return _this;
    }

    (0, _createClass2.default)(BaseMultiLineSlider, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.onWindowScrollDebounce = (0, _debounce.default)(this.onWindowScroll, _sliderHelpers.DEBOUNCE_SCROLL); // viewport detection

        var breakpoint = (0, _breakpoints.getCurrentBreakpoint)();
        var isXLargeDevice = ['xlarge', 'xxlarge'].indexOf(breakpoint) !== -1;
        var isMediumDevice = ['medium', 'large'].indexOf(breakpoint) !== -1;
        var isSmallDevice = !isXLargeDevice && !isMediumDevice;
        this.setState({
          isSmallDevice: isSmallDevice,
          touchDevice: 'ontouchstart' in global && global.innerWidth <= _breakpoints.nextBreakpoints.LARGE
        }); // listen to events

        if (this.renderSlider && !this.props.placeholders) {
          this.initEvents();
        }
      } // if we change from placeholders to real teasers, start listening to the events

    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        // tbc: should we add typeof window !== 'undefined' to make sure it is not called on SSR ?
        if (this.props.placeholders > 0 && nextProps.placeholders === 0) {
          this.setState({
            lessThan4Items: haveLessThan(nextProps.teasers, nextProps, 4)
          });
          this.initEvents();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        global.removeEventListener('scroll', this.onWindowScrollDebounce);
        this.mediaQueryListS.removeListener(this.onChangedMediaQueryS);
        this.mediaQueryListM.removeListener(this.onChangedMediaQueryM);
        this.mediaQueryListXL.removeListener(this.onChangedMediaQueryXL);
      }
      /**
       * On media query change, compute the teasers again
       */

    }, {
      key: "onArrowClick",

      /**
       * On arrow button click:
       * - calculate the translate width
       * - translate the slider for {translateX} pixels
       * - update the visibility of arrows buttons
       * IMPORTANT: translateX is calculated on arrow clic because the slides:
       * - can have different sizes
       * - can have changed after a resize / breakpoint change
       */
      value: function onArrowClick(direction) {
        var translateWidths = this.state.translateWidths;
        var _this$state4 = this.state,
            translateIndex = _this$state4.translateIndex,
            translateX = _this$state4.translateX;

        if (direction > 0) {
          if (!translateWidths[translateIndex]) {
            var translateWidth = (0, _sliderHelpers.getTranslateWidth)(this.slides, [_MultiLineSlider.StyledSlideBig, _MultiLineSlider.StyledSlideDual], Math.abs(translateX));
            translateWidths.push(translateWidth);
          }

          translateX -= translateWidths[translateIndex++];
        } else {
          translateX += translateWidths[--translateIndex];
        }

        this.setState({
          showPrev: translateX < 0,
          showNext: this.slides.scrollWidth > Math.abs(translateX) + this.slides.offsetWidth,
          translateIndex: translateIndex,
          translateWidths: translateWidths,
          translateX: translateX
        });
      }
    }, {
      key: "initEvents",
      value: function initEvents() {
        global.addEventListener('scroll', this.onWindowScrollDebounce);
        this.onWindowScrollDebounce();
        this.mediaQueryListS = global.matchMedia('(max-width: 767px)');
        this.mediaQueryListM = global.matchMedia('(min-width: 768px) and (max-width: 1199px)');
        this.mediaQueryListXL = global.matchMedia('(min-width: 1200px)');
        this.mediaQueryListS.addListener(this.onChangedMediaQueryS);
        this.mediaQueryListM.addListener(this.onChangedMediaQueryM);
        this.mediaQueryListXL.addListener(this.onChangedMediaQueryXL);
      }
    }, {
      key: "renderMobileSlide",
      value: function renderMobileSlide(teaser) {
        var isSmallDevice = this.state.isSmallDevice;
        var _this$props2 = this.props,
            kind = _this$props2.kind,
            placeholders = _this$props2.placeholders;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "next-mobile-teaser"
        }, /*#__PURE__*/_react.default.createElement(_TeaserShow.default, (0, _extends2.default)({
          className: "next-teaser-mobile",
          hover: "overlay",
          visible: isSmallDevice,
          titlesElement: /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
            isPlaceholder: placeholders > 0,
            display: "MOBILE",
            slideKind: kind ? kind.code : null,
            subtitle: teaser.subtitle,
            title: teaser.title
          })
        }, teaser)));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            title = _this$props3.title,
            teasers = _this$props3.teasers;
        var mobileSlide = this.renderMobileSlide(teasers[0]);
        var slider = this.renderSlider();
        return /*#__PURE__*/_react.default.createElement("div", null, title !== null && /*#__PURE__*/_react.default.cloneElement(title, {
          className: 'next-multilines-slider-title'
        }), mobileSlide, slider);
      }
    }]);
    return BaseMultiLineSlider;
  }(_react.Component);

  BaseMultiLineSlider.propTypes = {
    kind: _propTypes.default.string,
    placeholders: _propTypes.default.number,
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    reverse: _propTypes.default.bool,
    title: _propTypes.default.node
  };
  BaseMultiLineSlider.defaultProps = {
    kind: '',
    placeholders: 0,
    teasers: [],
    reverse: false,
    title: null
  };
  var _default = BaseMultiLineSlider;
  _exports.default = _default;
});